import { render, staticRenderFns } from "./DfYoutube.vue?vue&type=template&id=72986aa2&"
import script from "./DfYoutube.vue?vue&type=script&lang=js&"
export * from "./DfYoutube.vue?vue&type=script&lang=js&"
import style0 from "./DfYoutube.vue?vue&type=style&index=0&id=72986aa2&prod&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports